import type { QontoEmberPartialConfig } from '../../config/environment';

export const getEnvironmentVariables = (): QontoEmberPartialConfig => {
  const metaTag =
    typeof document !== 'undefined'
      ? document.querySelector("meta[name^='qonto'][name$='/config/environment']")
      : null;
  const content = metaTag?.getAttribute('content') || '{}';

  try {
    const decodedContent = decodeURIComponent(content);
    return JSON.parse(decodedContent) as QontoEmberPartialConfig;
  } catch (error) {
    console.error('Failed to parse environment variables from meta tag:', error);
    return {} as QontoEmberPartialConfig;
  }
};
